module.exports = __webpack_public_path__ + "img/achievement_27.6c9995a7.png";